import instance from "../redux/actions/AxiosInstance/authenticated";

export const fetchSalesData = async (asin, bsr, category) => {
  try {
    const response = await instance.post("/getsales", {
      asin,
      bsr,
      category,
    });

    return response?.data;
  } catch (error) {
    console.error("Error:", error);
  }
};

export const fetchProductDetails = async (asin) => {
  try {
    const response = await instance.post("/productinfo", { asin });
    await addHistory(asin);
    return response?.data;
  } catch (error) {
    console.error("Error:", error);
  }
};

export const addHistory = async (asin) => {
  try {
    const response = await instance.post("/history/add", { asin });

    return response?.data;
  } catch (error) {
    console.error("Error:", error);
  }
};

export const checkAmazonEligibility = async (asin) => {
  try {
    const response = await instance.post("/amazon-seller/check-eligibility", {
      asin: asin,
    });

    return response?.data?.data[0];
  } catch (error) {
    console.error("Error:", error);
  }
};

export const checkAmazonAuthStatus = async () => {
  try {
    const response = await instance.get("/amazon-seller/auth-status");
    return response.data;
  } catch (err) {
    console.error("Error:", err);
  }
};

export const addLookup = async (data) => {
  try {
    const response = await instance.post("/lookup/add", data);

    return response?.data;
  } catch (error) {
    console.error("Error:", error);
  }
};

export const fetchLookups = async (asin) => {
  try {
    const response = await instance.post("/lookup", { asin });

    return response?.data;
  } catch (error) {
    console.error("Error:", error);
  }
};

export const updateSpreadsheetId = async (spreadsheetId) => {
  try {
    const response = await instance.post("/user/createcsv", {
      spreadsheetId,
    });

    return response?.data;
  } catch (error) {
    console.error("Error:", error);
  }
};

export const searchProducts = async (searchterm) => {
  try {
    const response = await instance.post("/search", {
      searchterm: searchterm,
    });

    return response?.data;
  } catch (error) {
    console.error("Error:", error);
  }
};

export const addFavorite = async (asin) => {
  try {
    const response = await instance.post("/favorites/add", { asin });
    return response?.data;
  } catch (error) {
    console.error("Error:", error);
  }
};

export const removeFavorite = async (asin) => {
  try {
    const response = await instance.delete("/favorites", { data: { asin } });
    return response?.data;
  } catch (error) {
    console.error("Error:", error);
  }
};

export const getFavorites = async () => {
  try {
    const response = await instance.post("/favorites");
    return response?.data;
  } catch (error) {
    console.error("Error:", error);
  }
};